import Axios from "../services/axios.service";

export default class ReportService {
  static async payOutReport(payload) {
    return Axios({
      method: "POST",
      url: "/web-services/api/v6/services/report/transaction/pay-out-report",
      data: payload,
    });
  }

  static async unlockTransaction(id) {
    return Axios({
      method: "GET",
      url: `/web-services/api/v6/services/admin/transaction-management/unlocktransaction/${id}`,
    });
  }
}
